import {Injectable} from '@angular/core';
import {
  DialogData
} from './components/auswertungen-formdialog-neu/auswertungen-formdialog-neu.component';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CollectionApiResponse} from '../../../lib/util/api-response';
// @ts-ignore
import {FilterSucheItem} from './filterSucheModel';
import {FilterItem} from './filter.model';
import {NodeItem} from '../projektverwaltung/node.model';
import {mitarbeiterverwaltungReducer} from '../Mitarbeiterverwaltung/store/reducer/mitarbeiterverwaltung.reducer';
type Nodes = CollectionApiResponse<NodeItem>;

type ZeitOutputResponse = CollectionApiResponse<DialogData>;

@Injectable({ providedIn: 'root'})

export class AuswertungenService {

  constructor(private http: HttpClient) { }

  /**
   * shows the time table
   *
   * @returns - An observable that emits the added parts of timetable
   */
  public getAll(): Observable<ZeitOutputResponse> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }
    const session = sessionStorage.getItem('session');
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/zeiterfassung/getAll_select_zeit.php?userId=${userId}&${session}`) as Observable<ZeitOutputResponse>;
  }


  /*Filter Suche Datum nach Joel*/
  public getFilteredSeekDate(item: FilterItem): Observable<ZeitOutputResponse> {
    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }

    const filterItem = item;
    // tslint:disable-next-line:max-line-length
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/auswertungen/getFilteredZeit.php?userId=${userId}&${sessionStorage.getItem('session')}`, filterItem) as Observable<
      ZeitOutputResponse
      >;
  }

  public getProjektauswahlNodes(): Observable<Nodes> {

    let userId = null;
    if (isNaN( Number(sessionStorage.getItem('zeitUserId'))) === false && sessionStorage.getItem('zeitUserId') !== null){
      userId = sessionStorage.getItem('zeitUserId');
    }
    else{
      userId = sessionStorage.getItem('userId');
    }
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/auswertungen/getAllProjektauswahl.php?userId=${userId}&${sessionStorage.getItem('session')}`) as Observable<
      Nodes
      >;
  }

}
